window.addEventListener('DOMContentLoaded', () => {
    const tabTriggers = document.querySelectorAll('.js_oraOfferTabs__nav__btn')
    const tabs = document.querySelectorAll('.oraOfferTabs__tab')

    tabTriggers.forEach((trigger) => {
        const tab = trigger.getAttribute('data-tab')

        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            // change active class for menu
            [...tabTriggers].map((x) =>
                x.dataset.tab === tab
                    ? x.classList.add('oraOfferTabs__nav__btn--active')
                    : x.classList.remove('oraOfferTabs__nav__btn--active')
            );

            // change active class for tabs
            [...tabs].map((x) =>
                x.dataset.tab === tab
                    ? x.classList.add('oraOfferTabs__tab--active')
                    : x.classList.remove('oraOfferTabs__tab--active')
            );
        });
    });
})
